'use client';

import type { FormEventHandler, KeyboardEventHandler, ReactNode } from 'react';
import { isSearchConfirmShortcut } from '@/lib/keyboard-shortcuts';

interface LookupSearchPanelProps {
  onSubmit: FormEventHandler<HTMLFormElement>;
  children: ReactNode;
  className?: string;
}

export function LookupSearchPanel({
  onSubmit,
  children,
  className = 'mb-4 border border-border bg-card',
}: LookupSearchPanelProps) {
  const handleFormKeyDown: KeyboardEventHandler<HTMLFormElement> = (event) => {
    if (!isSearchConfirmShortcut(event)) return;
    event.preventDefault();
    event.stopPropagation();
    event.currentTarget.requestSubmit();
  };

  return (
    <div className={className} style={{ boxShadow: 'var(--shadow-warm-sm)' }}>
      <form onSubmit={onSubmit} onKeyDown={handleFormKeyDown}>
        {children}
      </form>
    </div>
  );
}

interface ButtonProgressBarProps {
  progress: number;
}

export function ButtonProgressBar({ progress }: ButtonProgressBarProps) {
  return (
    <>
      <span className="pointer-events-none absolute inset-x-0 bottom-0 h-[2px] bg-primary-foreground/25" />
      <span
        className="pointer-events-none absolute left-0 bottom-0 h-[2px] bg-primary-foreground transition-[width] duration-200 ease-out"
        style={{ width: `${Math.max(6, Math.min(100, progress))}%` }}
      />
    </>
  );
}
